export var AddressType;
(function (AddressType) {
    AddressType["HOME"] = "HOME";
    AddressType["BUSINESS"] = "BUSINESS";
    AddressType["OTHER"] = "OTHER";
    AddressType["DESTINATION"] = "DESTINATION";
})(AddressType || (AddressType = {}));
